module.exports = __webpack_public_path__ + "img/pr-6.c1d52443.png";